import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LegacyWidgetVisibilityService } from '../../service/legacy-widget-visibility.service';

@Directive({
  selector: '[appShowLegacy]'
})
export class ShowLegacyDirective implements OnInit, OnDestroy {
  private readonly ngDestroy$ = new Subject<void>();
  private hasView = false;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly visibility: LegacyWidgetVisibilityService
  ) {}

  ngOnInit(): void {
    this.visibility.visible$
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(visible => {
        if (visible && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
        } else if (!visible && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}
